import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { BEAT_DOT_SIZE, describeBeats, type BeatDot } from '../utils/beatsUtils';

interface BeatDotsProps {
  /** From `buildBeatDots` (the slot also measures them). */
  dots: BeatDot[];
  lengthUnits: number;
}

/** A slot's beats under its chord (Beats on). Mirrors RN's BeatDots. */
const BeatDots: React.FC<BeatDotsProps> = ({ dots, lengthUnits }) => {
  const { theme } = useTheme();

  return (
    <span
      role="img"
      aria-label={describeBeats(lengthUnits)}
      data-testid="beat-dots"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing.xs,
        marginTop: theme.spacing.xs,
      }}
    >
      {dots.map((dot, i) => (
        <span
          key={i}
          data-half={dot.half || undefined}
          style={{
            width: dot.half ? BEAT_DOT_SIZE / 2 : BEAT_DOT_SIZE,
            height: BEAT_DOT_SIZE,
            flexShrink: 0,
            borderRadius: theme.radii.full,
            backgroundColor: theme.colors.beats,
            marginLeft: dot.groupStart ? theme.spacing.xs : 0,
          }}
        />
      ))}
    </span>
  );
};

export default BeatDots;
